import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import brain from "@/store/modules/brain";
import modules from "@/store/modules/modules";
import drivers from "@/store/modules/drivers";
import solutions from "@/store/modules/solutions";
import history from "@/store/modules/history";
import global from "@/store/modules/global";
import emergencyDrivers from "@/store/modules/emergencyDrivers";
import undo from "./plugins/undo";
import autosave from "./plugins/autosave";

import { set, get, omit } from "lodash";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    brain,
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    undo,
    autosave,
    createPersistedState({
      paths: ["brain.ui"],
      reducer: (state, paths) => {
        let output = {};
        paths.map((path) => {
          set(output, path, get(state, path));
        });
        return omit(output, "brain.ui.showSpinner");
      },
    }),
  ],
});

store.registerModule(["brain", "modules"], modules);
store.registerModule(["brain", "drivers"], drivers);
store.registerModule(["brain", "solutions"], solutions);
store.registerModule(["brain", "history"], history);
store.registerModule(["brain", "global"], global);
store.registerModule(["brain", "emergencyDrivers"], emergencyDrivers);

export default store;
